import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Divider, Stack, Typography, useTheme } from '@mui/material';

import { TalentCreateDTO, TalentDTO } from '@/api/generated';
import HeaderProperty from '@/components/HeaderProperty';
import SeparatedList from '@/components/SeparatedList';
import { UserAvatar } from '@/components/UserAvatar';
import { useIsMidotUser } from '@/hooks/permissions/useIsMidotUser';

const TalentInfoRow = ({ talent }: { talent?: TalentDTO }) => {
  const { t } = useTranslation(['talents', 'common']);
  const { spacing } = useTheme();
  const { getValues } = useFormContext<TalentCreateDTO>();
  const talentData = getValues();
  const { isMidotUser } = useIsMidotUser();

  return (
    <Stack direction="row" alignItems="center" sx={{ mx: spacing(5), paddingTop: spacing(2) }}>
      <UserAvatar user={talentData} variant="talent-xsmall" />
      <Typography component="h2" variant="h2" sx={{ marginInlineStart: spacing(1) }}>
        {t('common:header.user.fullName', {
          firstName: talentData.firstName,
          lastName: talentData.lastName
        })}
      </Typography>
      <SeparatedList
        separator={<Divider orientation="vertical" flexItem sx={{ m: spacing(0, 3) }} />}
        sx={{ alignItems: 'center', marginInlineStart: spacing(3) }}
      >
        <Typography variant="body3" color="grey.800">
          {talentData.organizationSlug}
        </Typography>
        {isMidotUser && talent && (
          <HeaderProperty sx={{ margin: 0 }} label={t('talents:layouts.talents.columns.id')} fallback="-">
            {talent.id}
          </HeaderProperty>
        )}
        <HeaderProperty sx={{ margin: 0 }} label={t('talents:layouts.talents.columns.email')} fallback="-">
          {talentData.email}
        </HeaderProperty>
        <HeaderProperty sx={{ margin: 0 }} label={t('talents:layouts.talents.columns.phone')} fallback="-">
          {talentData.phone}
        </HeaderProperty>
        {talentData.type && (
          <Typography variant="body3" color="grey.800">
            {t(`filters:filters.options.talentTypes.${talentData.type.toLowerCase()}`)}
          </Typography>
        )}
      </SeparatedList>
    </Stack>
  );
};

export default TalentInfoRow;
